import { render, staticRenderFns } from "./DisclaimerPolicy.vue?vue&type=template&id=7a7af29c&"
import script from "./DisclaimerPolicy.vue?vue&type=script&lang=js&"
export * from "./DisclaimerPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports